import { Box, Button, Container, Paper } from '@mui/material';
import { SiTrackPage } from '../../../components/si-track-page';
import { useLoadData } from '../../../hooks/useLoadData';
import { qbApiKeyStore } from '../../../api/quickbook-api-key-store';
import { QboState } from './qbo-state.component';
import { ApiResponse } from '../../../models/api-response';
import { useEffect } from 'react';
import { useSaveData } from '../../../hooks/useSaveData';

export const QuickBookPage = () => {
  // const { data, isLoading } = useLoadData<ApiResponse<any>>(qbApiKeyStore.qbologin());
  // useEffect(() => {
  //   if (data?.data?.oAuthUrl) {
  //     // Open the OAuth URL in a new tab
  //     window.open(data.data.oAuthUrl, '_blank');
  //   }
  // }, [data]);
  const { isLoading, mutateAsync } = useSaveData<any>(qbApiKeyStore.qbologin());
  const handleQuickbookClick = () => {
    mutateAsync({ data: {} }).then((data) => {
      if (data?.data?.oAuthUrl) {
        window.open(data.data.oAuthUrl, '_blank');
      }
    });
  };
  return (
    <SiTrackPage title="Quick Book" isLoading={isLoading}>
      <Container sx={{ textAlign: 'center', mt: 10 }}>
        <Box
          sx={{
            display: 'inline-block',
            borderRadius: '12px',
            backgroundColor: '#f2f2f2',
            padding: '40px',
            boxShadow: '0 3px 6px rgba(0,0,0,0.1)',
          }}
        >
          <Button
            variant="contained"
            color="primary"
            size="large"
            onClick={() => handleQuickbookClick()}
            sx={{ mt: 3 }}
          >
            Connect to Quickbooks
          </Button>
        </Box>
      </Container>
    </SiTrackPage>
  );
};
